import { request } from '@/shared/api/request'

export const addMembers = (externalId, params, data) => {
	return request({ url: `colcontract/tradeUnion/person/add/${externalId}`, method: 'POST', params, data: data })
}
